// extracted by mini-css-extract-plugin
module.exports = {"container":"ConditionsErrorCard_container__PlxDu","nullState":"ConditionsErrorCard_nullState__tBMAc"};